import api from "./Api";

class FiscalSintegraService {
  GetJobsOData(payload) {
    return api.get("/v1/fiscal/sintegra/jobs" + payload).then((response) => {
      return response.data;
    });
  }

  PostJob(payload) {
    return api.post("/v1/fiscal/sintegra/jobs", payload).then((response) => {
      return response.data;
    });
  }

  DeleteJob(payload) {
    return api
      .delete("/v1/fiscal/sintegra/jobs/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  DownloadJob(payload) {
    return api
      .get("/v1/fiscal/sintegra/jobs/" + payload + "/download", {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  GetFiltros() {
    return api.get("/v1/fiscal/sintegra/filtros").then((response) => {
      return response.data;
    });
  }
}

export default new FiscalSintegraService();
